/* eslint-disable no-shadow */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/react-in-jsx-scope */
import { useState, useRef } from 'react';
import {
  Stack, IconButton, InputAdornment, TextField, Box,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useSelector, useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';
import { appSliceActions } from '../../appSlices/appSlice';
import axiosInstance from '../../utils/axiosInstance';
import Iconify from '../iconify';
import SingleSelector from '../single-selector/singleSelector';
import fetchDeviceList from '../../utils/fetchDeviceList';
import fetchStreamList from '../../utils/fetchStreamList';

export default function SensorCredentials() {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const [sensor, setSensor] = useState(null);
  const sensorList = useSelector((state) => state.app.sensorList);
  const usernameRef = useRef();
  const [showPassword, setShowPassword] = useState(false);
  const passwordRef = useRef();

  const sensorCredentialsApi = () => {
    const jsonData = {
      username: usernameRef.current.value,
      password: passwordRef.current.value,
    };
    axiosInstance
      .post(`${window.location.protocol}//${sensor.host}/api/v1/sensor/${sensor.sensorId}/credentials`, jsonData, { headers: { "streamId": sensor.sensorId } })
      .then(async () => {
        enqueueSnackbar(`Success - sensor credentials verified for ${sensor.name}`, {
          variant: 'success',
          anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
        });
        const sensorList = await fetchDeviceList(sensor.host);
        if (sensorList != null) {
          for (let i = 0; i < sensorList.length; i += 1) {
            sensorList[i].host = sensor.host;
          }
          dispatch(appSliceActions.addDevice(sensorList));
        }
        const streamList = await fetchStreamList(sensor.host);
        if (streamList != null) {
          for (let i = 0; i < streamList.length; i += 1) {
            streamList[i].host = sensor.host;
          }
          dispatch(appSliceActions.addStream(streamList));
        }
      })
      .catch((error) => {
        if (error.response.data == null) {
          enqueueSnackbar(`Error - ${error.response.status}`, {
            variant: 'error',
            anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
          });
        } else {
          enqueueSnackbar(`Error - ${error.response.data.error_message}`, {
            variant: 'error',
            anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
          });
        }
      });
  };

  const handleSubmit = () => {
    enqueueSnackbar('Pending - verify sensor credentials', {
      variant: 'info',
      anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
    });
    if (!sensor) {
      enqueueSnackbar('Error - Please select sensor', {
        variant: 'error',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });
      return;
    }
    if (!usernameRef.current.value || !passwordRef.current.value) {
      enqueueSnackbar('Error - Please enter username and password', {
        variant: 'error',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });
      return;
    }
    sensorCredentialsApi();
  };

  // Function to filter unauthorized sensors
  const filterUnauthorized = (sensorList) => sensorList
    .filter((sensor) => sensor.isAuthorized === false);

  return (
    <>
      <Stack spacing={3} sx={{ mb: 2 }}>
        <SingleSelector
          id="verify-sensors"
          placeholder="Type to search"
          label="Select sensors"
          value={sensor}
          onChange={setSensor}
          getOptionLabel={(option) => {
            if (option.remoteDeviceName && option.remoteDeviceLocation) {
              return `${option.name} at ${option.remoteDeviceName} (${option.remoteDeviceLocation})`;
            } if (option.remoteDeviceName) {
              return `${option.name} at ${option.remoteDeviceName}`;
            }
            return option.name;

          }}
          options={filterUnauthorized(sensorList)}
        />
        <TextField name="username" label="username" inputRef={usernameRef} />
        <TextField
          name="password"
          label="Password"
          type={showPassword ? 'text' : 'password'}
          inputRef={passwordRef}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                  <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Stack>
      <Box m={1} display="flex" justifyContent="flex-end" alignItems="flex-end">
        <LoadingButton size="large" type="submit" variant="contained" onClick={handleSubmit}>
          Submit
        </LoadingButton>
      </Box>
    </>
  );
}
